module.exports = __webpack_public_path__ + "static/img/logo.d7ee71a6.png";